import React from 'react';
import styled from 'styled-components';

import {overflowWrap} from 'styles/mixins';
import {pxToRem} from 'utils/ui';
import AssetIcon from 'components/AssetIcon';
import ButtonCore from 'components/ButtonCore';
import Card from 'components/Card';
import CardImage from 'components/CardImage';

const Wrapper = styled(ButtonCore)`
	position: relative;

	display: block;
	width: 100%;

	font-weight: bold;

	color: ${p => p.theme.text};
	background: transparent;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;

		background-color: ${p => p.theme.shade};

		border-radius: ${p => pxToRem(p.theme.globals.borderRadius.large)};

		opacity: 0;
		transition: opacity 250ms ease-out;
		will-change: opacity;
	}

	&:hover::before,
	&:focus::before {
		opacity: ${p => p.theme.shadeStrength};
	}
`;

const Content = styled.span`
	position: relative;
	display: block;
	padding: ${p => p.theme.globals.spacing.xxs}
		${p => p.theme.globals.spacing.xs};

	${overflowWrap}

	transform: translateZ(0);
`;

function TopicCard(props) {
	const {children, icon, imageSrc, as, ...otherProps} = props;

	return (
		<Wrapper {...otherProps} forwardedAs={as}>
			<Card position="relative">
				<CardImage
					src={imageSrc}
					aspectRatio={5 / 8}
					colorBlock={icon}
					fallbackContent={<AssetIcon size="big" name={icon} />}
					minHeight={103}
				/>
			</Card>
			<Content>{children}</Content>
		</Wrapper>
	);
}

export default TopicCard;
